import React from "react";
import { ChallengeVIConfig } from "../../models/Types";
import { useTranslation } from "react-i18next";

export default function ChallengeVI(props: ChallengeVIConfig) {
  const { t } = useTranslation();

  function submitViSolution() {
    return props.submitVisualSolutionCallback({ visuallyImpaired: true });
  }

  return (
    <div className={"visuallyImpaired"}>
      {
        <p>
          {t("VisuallyImpairedPrompt.text")}{" "}
          <a tabIndex={0} onClick={submitViSolution}>
            {t("SolveAChallenge.text")}
          </a>
          .
        </p>
      }
    </div>
  );
}
